import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { Component } from "react";
import { Box, Button, Flex, Image, Text } from "rebass";
import styled from "styled-components";
import { KEY_NAME, KEY_PHONE } from "./data/localstorage";
import phone from "phone";

export const FullHeightFlex = styled(Flex)`
  height: 100vh;
`;

const TextInput = props => (
  <Box
    {...props}
    as="input"
    px={3}
    py={3}
    borderRadius={0}
    boxShadow={0}
    fontSize={2}
  />
);

const StyledTextInput = styled(TextInput)`
  border: 0;
  border-bottom: 1px solid #eee;
`;

const NameInput = ({
  field,
  form: { values, handleChange, handleBlur },
  ...props
}) => (
  <StyledTextInput
    type="text"
    {...field}
    {...props}
    placeholder="Full Name"
    required
    onChange={handleChange}
    onBlur={handleBlur}
    value={values.name}
  />
);

function validatePhoneNumber(value) {
  let errorMessage;
  if (phone(value).length < 1) {
    errorMessage = "Enter a valid number";
  }
  return errorMessage;
}

const PhoneInput = ({
  field,
  form: { values, handleChange, handleBlur },
  ...props
}) => (
  <StyledTextInput
    type="tel"
    {...field}
    {...props}
    placeholder="Phone #"
    required
    onChange={handleChange}
    onBlur={handleBlur}
    value={values.phone}
  />
);

const StyledErrorMessage = styled(Text)`
  color: #cc0f0f;
  padding-left: 10px;
`;

class InputLogin extends Component {
  onLogin = values => {
    const formattedPhone = phone(values.phone)[0]; // Save formatted to E.164 standard.
    localStorage.setItem(KEY_NAME, values.name);
    localStorage.setItem(KEY_PHONE, formattedPhone);
    this.props.history.push("/");
  };

  render() {
    return (
      <FullHeightFlex
        flexDirection="column"
        alignItems="center"
        justifyContent="start"
        pt="15vh"
      >
        <Image src="/hangtime-logo.png" width={0.8} mx={5} mb={4} />

        <Formik initialValues={{ name: "", phone: "" }} onSubmit={this.onLogin}>
          {({ values, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              <Flex
                flexDirection="column"
                alignItems="stretch"
                justifyContent="center"
                width="90vw"
                py={3}
              >
                <Field name="name" component={NameInput} />
                <ErrorMessage name="name" component="div" />
                <Field
                  name="phone"
                  component={PhoneInput}
                  validate={validatePhoneNumber}
                />
                <ErrorMessage name="phone" component={StyledErrorMessage} />
                <Button
                  bg="#999"
                  py={3}
                  mt={3}
                  fontSize={2}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Sign Up
                </Button>
              </Flex>
            </Form>
          )}
        </Formik>
      </FullHeightFlex>
    );
  }
}

export default InputLogin;
